import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileTabNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'document', label: 'Document', icon: 'FileText' },
    { id: 'results', label: 'Results', icon: 'FileSearch' },
    { id: 'email', label: 'Email', icon: 'Mail' }
  ];

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border z-navigation">
      <div className="flex">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            data-tab={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 flex flex-col items-center justify-center py-3 px-2
              transition-colors duration-200
              ${activeTab === tab.id
                ? 'text-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
              }
            `}
          >
            <Icon 
              name={tab.icon} 
              size={20} 
              color={activeTab === tab.id ? 'var(--color-primary)' : 'currentColor'} 
            />
            <span className="text-xs font-medium mt-1">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileTabNavigation;